(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7262],{

/***/ 65235:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 77913:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _router = __webpack_require__(12199);

var _formatUrl = __webpack_require__(17389);

var _addLocale = __webpack_require__(51630);

var _routerContext = __webpack_require__(59541);

var _appRouterContext = __webpack_require__(6163);

var _useIntersection = __webpack_require__(27215);

var _getDomainLocale = __webpack_require__(65235);

var _addBasePath = __webpack_require__(70729);

var prefetched = new Set();

function prefetch(router, href, as, options) {
  if (false) {}

  if (!(0, _router).isLocalURL(href)) {
    return;
  } // We should only dedupe requests when experimental.optimisticClientCache is
  // disabled.


  if (!options.bypassPrefetchedCheck) {
    var locale = // Let the link's locale prop override the default router locale.
    typeof options.locale !== 'undefined' ? options.locale : 'locale' in router ? router.locale : undefined;
    var prefetchedKey = href + '%' + as + '%' + locale; // If we've already fetched the key, then don't prefetch it again!

    if (prefetched.has(prefetchedKey)) {
      return;
    } // Mark this URL as prefetched.


    prefetched.add(prefetchedKey);
  } // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch


  Promise.resolve(router.prefetch(href, as, options))["catch"](function (err) {
    if (false) {}
  });
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      router[replace ? 'replace' : 'push'](as || href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react["default"].startTransition(navigate);
  } else {
    navigate();
  }
}

function formatStringOrUrl(urlObjOrString) {
  if (typeof urlObjOrString === 'string') {
    return urlObjOrString;
  }

  return (0, _formatUrl).formatUrl(urlObjOrString);
}
/**
 * React Component that enables client-side transitions between routes.
 */


var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      onMouseEnterProp = props.onMouseEnter,
      onTouchStartProp = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? true === false : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var prefetchEnabled = prefetchProp !== false;

  var pagesRouter = _react["default"].useContext(_routerContext.RouterContext);

  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);

  var router = pagesRouter != null ? pagesRouter : appRouter; // We're in the app directory if there is no pages router.

  var isAppRouter = !pagesRouter;

  if (false) { var hasDynamicSegment, _href; }

  var _react$default$useMem = _react["default"].useMemo(function () {
    if (!pagesRouter) {
      var _resolvedHref = formatStringOrUrl(hrefProp);

      return {
        href: _resolvedHref,
        as: asProp ? formatStringOrUrl(asProp) : _resolvedHref
      };
    }

    var _resolveHref = (0, _router).resolveHref(pagesRouter, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(pagesRouter, asProp) : resolvedAs || resolvedHref
    };
  }, [pagesRouter, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  } else {
    if (false) { var ref; }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]); // Prefetch the URL if we haven't already and it's visible.


  _react["default"].useEffect(function () {
    if (!router) {
      return;
    } // If we don't need to prefetch the URL, don't do prefetch.


    if (!isVisible || !prefetchEnabled) {
      return;
    } // Prefetch the URL.


    prefetch(router, href, as, {
      locale: locale
    });
  }, [as, href, isVisible, locale, prefetchEnabled, pagesRouter == null ? void 0 : pagesRouter.locale, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!router) {
        return;
      }

      if (e.defaultPrevented) {
        return;
      }

      linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled);
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof onMouseEnterProp === 'function') {
        onMouseEnterProp(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      }

      if (!router) {
        return;
      }

      if (!prefetchEnabled && isAppRouter) {
        return;
      }

      prefetch(router, href, as, {
        locale: locale,
        priority: true,
        // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
        bypassPrefetchedCheck: true
      });
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof onTouchStartProp === 'function') {
        onTouchStartProp(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      }

      if (!router) {
        return;
      }

      if (!prefetchEnabled && isAppRouter) {
        return;
      }

      prefetch(router, href, as, {
        locale: locale,
        priority: true,
        // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
        bypassPrefetchedCheck: true
      });
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : pagesRouter == null ? void 0 : pagesRouter.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = (pagesRouter == null ? void 0 : pagesRouter.isLocaleDomain) && (0, _getDomainLocale).getDomainLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.locales, pagesRouter == null ? void 0 : pagesRouter.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 27215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(67294);

var _requestIdleCallback = __webpack_require__(98065);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements["delete"](element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 1723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ SpacedHeaderFromLevel; },
/* harmony export */   "H": function() { return /* binding */ H; },
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H3": function() { return /* binding */ H3; },
/* harmony export */   "H4": function() { return /* binding */ H4; },
/* harmony export */   "H5": function() { return /* binding */ H5; },
/* harmony export */   "H6": function() { return /* binding */ H6; },
/* harmony export */   "X6": function() { return /* binding */ Heading; }
/* harmony export */ });
/* unused harmony export HeaderSpacing */
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["size", "as", "children"],
    _excluded2 = ["Component"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Heading = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
  displayName: "Headers__Heading",
  componentId: "sc-1lr3p22-0"
})(["width:100%;margin-bottom:0;", ";", ";", ";"], function (_ref) {
  var centered = _ref.centered;
  return centered && 'text-align: center';
}, function (_ref2) {
  var regularWeight = _ref2.regularWeight;
  return regularWeight && 'font-weight: 200;';
}, function (_ref3) {
  var theme = _ref3.theme;
  return "color: ".concat(theme ? theme.headers : 'inherit');
});
var StyledHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
  displayName: "Headers__StyledHeader",
  componentId: "sc-1lr3p22-1"
})(["", " ", " ", " ", ""], styled_system__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .typography */ .cp, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .border */ .Cg);
var sizeMap = {
  h1: {
    fontSize: ['xl', null, null, 'xxl'],
    lineHeight: '1.2',
    letterSpacing: '-0.011em'
  },
  h2: {
    fontSize: ['lg', null, null, 'xl'],
    lineHeight: '1.2',
    letterSpacing: '-0.011em'
  },
  h3: {
    fontSize: ['md', null, null, 'lg'],
    lineHeight: '1.2',
    letterSpacing: '-0.011em'
  },
  h4: {
    fontSize: ['s'],
    lineHeight: '1.2',
    letterSpacing: '-0.011em'
  },
  h5: {
    fontSize: ['xs'],
    lineHeight: '1.2',
    letterSpacing: '-0.011em'
  },
  h6: {
    fontSize: ['xxs'],
    lineHeight: '1.2',
    letterSpacing: '-0.011em'
  }
};
var H = function H(_ref4) {
  var size = _ref4.size,
      as = _ref4.as,
      children = _ref4.children,
      props = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref4, _excluded);

  var sizesConfig = sizeMap[size] || sizeMap[as] || sizeMap['h2'];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledHeader, _objectSpread(_objectSpread(_objectSpread({
    as: as,
    fontWeight: "bold"
  }, sizesConfig), props), {}, {
    children: children
  }));
};
var H1 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(Heading).withConfig({
  displayName: "Headers__H1",
  componentId: "sc-1lr3p22-2"
})(["", ""], function (_ref5) {
  var theme = _ref5.theme;
  return "\n    font-size: ".concat(theme.fontSizes['4xl'], ";\n    line-height: ").concat(theme.leadings['3xl'], ";\n  ");
});
var H2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(Heading).attrs({
  as: 'h2'
}).withConfig({
  displayName: "Headers__H2",
  componentId: "sc-1lr3p22-3"
})(["", ""], function (_ref6) {
  var theme = _ref6.theme;
  return "\n    font-size: ".concat(theme.fontSizes['2xl'], ";\n    line-height: ").concat(theme.leadings.xl, ";\n  ");
});
var H3 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(Heading).attrs({
  as: 'h3'
}).withConfig({
  displayName: "Headers__H3",
  componentId: "sc-1lr3p22-4"
})(["font-size:26px;line-height:34px;"]);
var H4 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(Heading).attrs({
  as: 'h4'
}).withConfig({
  displayName: "Headers__H4",
  componentId: "sc-1lr3p22-5"
})(["", ""], function (_ref7) {
  var theme = _ref7.theme;
  return "\n    font-weight: 500;\n    line-height: ".concat(theme.leadings.md, ";\n    font-size: ").concat(theme.fontSizes['lg'], ";\n  ");
});
var H5 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(Heading).attrs({
  as: 'h5'
}).withConfig({
  displayName: "Headers__H5",
  componentId: "sc-1lr3p22-6"
})(["", ""], function (_ref8) {
  var theme = _ref8.theme;
  return "\n    font-weight: 500;\n    font-size: ".concat(theme.fontSizes.lg, ";\n    line-height: ").concat(theme.leadings.xxs, ";\n  ");
});
var H6 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(Heading).attrs({
  as: 'h6'
}).withConfig({
  displayName: "Headers__H6",
  componentId: "sc-1lr3p22-7"
})(["font-weight:500;line-height:16px;font-size:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes.xs;
});
var spacedHeadersConfig = {
  1: {
    Component: H1,
    top: 6,
    bottom: 3
  },
  2: {
    Component: H2,
    top: 5,
    bottom: 3
  },
  3: {
    Component: H3,
    top: 4,
    bottom: 1
  },
  4: {
    Component: H4,
    top: 4,
    bottom: 1
  },
  5: {
    Component: H5,
    top: 4,
    bottom: 1
  },
  6: {
    Component: H6,
    top: 2.5,
    bottom: 1.5
  }
};
var HeaderSpacing = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Headers__HeaderSpacing",
  componentId: "sc-1lr3p22-8"
})(["", ""], function (_ref10) {
  var top = _ref10.top,
      bottom = _ref10.bottom;
  return "\n    margin-top: ".concat(top, "rem;\n    margin-bottom: ").concat(bottom, "rem;\n  ");
});
var SpacedHeaderFromLevel = function SpacedHeaderFromLevel(_ref11) {
  var level = _ref11.level,
      text = _ref11.text,
      _ref11$configOverride = _ref11.configOverride,
      configOverride = _ref11$configOverride === void 0 ? {} : _ref11$configOverride;

  var finalConfig = _objectSpread(_objectSpread({}, spacedHeadersConfig), configOverride);

  var _finalConfig$level = finalConfig[level],
      Component = _finalConfig$level.Component,
      spacing = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_finalConfig$level, _excluded2);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(HeaderSpacing, _objectSpread(_objectSpread({}, spacing), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
      children: text
    })
  }));
};

/***/ }),

/***/ 40815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ ChevronIcon; },
/* harmony export */   "Fc": function() { return /* binding */ YouTubeIcon; },
/* harmony export */   "LZ": function() { return /* binding */ ArrowRightIcon; },
/* harmony export */   "O7": function() { return /* binding */ CircleCloseIcon; },
/* harmony export */   "PV": function() { return /* binding */ DropDownArrowIcon; },
/* harmony export */   "Tw": function() { return /* binding */ CloseIcon; },
/* harmony export */   "Vq": function() { return /* binding */ FacebookIcon; },
/* harmony export */   "W1": function() { return /* binding */ SearchIcon; },
/* harmony export */   "Zm": function() { return /* binding */ TwitterIcon; },
/* harmony export */   "aY": function() { return /* binding */ TriangleArrow; },
/* harmony export */   "nI": function() { return /* binding */ LinkedInIcon; },
/* harmony export */   "o1": function() { return /* binding */ PlayIcon; },
/* harmony export */   "pO": function() { return /* binding */ PlusIcon; },
/* harmony export */   "r7": function() { return /* binding */ StarIcon; },
/* harmony export */   "u0": function() { return /* binding */ StopwatchIcon; }
/* harmony export */ });
/* unused harmony exports DocsIcon, MP4Icon, PdfIcon, MailIcon, CloseFormIcon */
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["height", "width"],
    _excluded2 = ["height", "width", "color"],
    _excluded3 = ["height", "width"],
    _excluded4 = ["height", "width"],
    _excluded5 = ["height", "width"],
    _excluded6 = ["height", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M11.88 0L7 4.88 2.12 0 0 2.12 4.878 7 0 11.88 2.12 14 7 9.12 11.88 14 14 11.88 9.122 7 14 2.12 11.88 0z",
      fill: "#fff"
    })
  }));
};
var FacebookIcon = function FacebookIcon(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 12 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 7.5 : _ref$width,
      restProps = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 25 53",
    role: "img",
    "aria-hidden": "true",
    "aria-label": "Facebook",
    alt: "Facebook"
  }, restProps), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M24.352 16.97h-8.294v-5.44c0-2.043 1.355-2.519 2.308-2.519h5.852V.031l-8.06-.03C7.21 0 5.173 6.696 5.173 10.982v5.986H0v9.253h5.175v26.184h10.884V26.222h7.345l.949-9.253z",
      fill: "#000",
      fillRule: "evenodd"
    })
  }));
};
var StarIcon = function StarIcon(_ref2) {
  var _theme$colors;

  var _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 24 : _ref2$height,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 24 : _ref2$width,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'white' : _ref2$color,
      restProps = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref2, _excluded2);

  var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 79.7 79.7",
    role: "img",
    "aria-hidden": "true"
  }, restProps), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M0 0h79.7v79.7H0z",
      fill: "transparent"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M39.9 53.9 52 50.7l5.1 15.7-17.2-12.5zm27.9-20.3H46.4l-6.6-20.3-6.6 20.3H11.8l17.3 12.6-6.6 20.3L39.8 54l10.7-7.8 17.3-12.6z",
      fill: (theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors[color]) || 'white'
    })]
  }));
};
var TwitterIcon = function TwitterIcon(_ref3) {
  var _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? 12 : _ref3$height,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? 12 : _ref3$width,
      restProps = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 50 41",
    role: "img",
    "aria-hidden": "true",
    "aria-label": "Twitter",
    alt: "Twitter"
  }, restProps), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M49.263 4.739a20.11 20.11 0 01-5.805 1.59A10.125 10.125 0 0047.902.739a20.232 20.232 0 01-6.418 2.454A10.093 10.093 0 0034.107 0c-5.58 0-10.106 4.525-10.106 10.107 0 .79.09 1.562.262 2.303-8.4-.422-15.848-4.445-20.833-10.56a10.055 10.055 0 00-1.368 5.082c0 3.506 1.784 6.6 4.496 8.412a10.078 10.078 0 01-4.578-1.265v.128c0 4.896 3.483 8.98 8.107 9.91a10.162 10.162 0 01-4.565.172c1.287 4.015 5.02 6.938 9.441 7.019a20.276 20.276 0 01-12.552 4.327c-.815 0-1.62-.048-2.41-.142a28.6 28.6 0 0015.492 4.54c18.591 0 28.756-15.4 28.756-28.755 0-.438-.009-.875-.028-1.31a20.47 20.47 0 005.042-5.23",
      fill: "#000",
      fillRule: "evenodd"
    })
  }));
};
var LinkedInIcon = function LinkedInIcon(_ref4) {
  var _ref4$height = _ref4.height,
      height = _ref4$height === void 0 ? 12 : _ref4$height,
      _ref4$width = _ref4.width,
      width = _ref4$width === void 0 ? 10.5 : _ref4$width,
      restProps = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref4, _excluded4);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 46 44",
    role: "img",
    "aria-hidden": "true",
    "aria-label": "LinkedIn",
    alt: "LinkedIn"
  }, restProps), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M45.43 43.423H35.69V27.745c0-3.937-1.409-6.624-4.932-6.624-2.69 0-4.291 1.812-4.997 3.563-.258.625-.32 1.5-.32 2.375v16.363h-9.739s.129-26.553 0-29.299h9.739v4.148c1.294-1.996 3.608-4.839 8.779-4.839 6.406 0 11.21 4.19 11.21 13.19v16.801h-.002zM5.445 10.123H5.38C2.113 10.123 0 7.873 0 5.06 0 2.188 2.178 0 5.51 0c3.331 0 5.38 2.188 5.445 5.06 0 2.813-2.116 5.063-5.51 5.063M.575 43.423h9.738V14.125H.575z",
      fill: "#000",
      fillRule: "evenodd"
    })
  }));
};
var YouTubeIcon = function YouTubeIcon(_ref5) {
  var _ref5$height = _ref5.height,
      height = _ref5$height === void 0 ? 12 : _ref5$height,
      _ref5$width = _ref5.width,
      width = _ref5$width === void 0 ? 13.5 : _ref5$width,
      restProps = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref5, _excluded5);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 55 44",
    role: "img",
    "aria-hidden": "true",
    "aria-label": "YouTube",
    alt: "YouTube"
  }, restProps), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M22 34.375V9.625L38.5 22 22 34.375zM49.5 1.1C47.85.55 37.675 0 27.5 0S7.15.55 5.5 1.1C1.1 2.475 0 12.1 0 22c0 9.9 1.1 19.525 5.5 20.9 1.65.55 11.825 1.1 22 1.1s20.35-.55 22-1.1c4.4-1.375 5.5-11 5.5-20.9 0-9.9-1.1-19.525-5.5-20.9z",
      fill: "#000",
      fillRule: "evenodd"
    })
  }));
};
var DropDownArrowIcon = function DropDownArrowIcon(_ref6) {
  var _ref6$height = _ref6.height,
      height = _ref6$height === void 0 ? 9 : _ref6$height,
      _ref6$width = _ref6.width,
      width = _ref6$width === void 0 ? 9 : _ref6$width,
      restProps = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref6, _excluded6);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 56 30",
    role: "img",
    "aria-hidden": "true"
  }, restProps), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M0 0l28 30L56 0z",
      fill: "#000232",
      fillRule: "evenodd"
    })
  }));
};
var ChevronIcon = function ChevronIcon(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    viewBox: "0 0 46 28",
    role: "img",
    "aria-hidden": "true",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M40.761 0L23 17.61 5.24 0 0 5.194 23 28 46 5.194z",
      fill: "#000",
      fillRule: "evenodd"
    })
  }));
};
var CircleCloseIcon = function CircleCloseIcon(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M36.375 32.132l-4.243 4.243L24 28.243l-8.131 8.132-4.243-4.243L19.758 24l-8.132-8.132 4.243-4.242L24 19.756l8.132-8.13 4.243 4.242L28.243 24l8.132 8.132zM24 0C10.746 0 0 10.745 0 24s10.746 24 24 24c13.255 0 24-10.745 24-24S37.255 0 24 0z",
      fill: "#000",
      fillRule: "evenodd"
    })
  }));
};
var DocsIcon = function DocsIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: "14",
    height: "18",
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.1682 4.93942V16.2523L12.5073 16.2134V5.08197L9.08618 1.66089H1.99781C1.81639 1.66089 1.67385 1.81639 1.67385 1.99781V16.5892C1.67385 16.7707 1.81639 16.9262 1.99781 16.9262H12.1703C12.3518 16.9262 12.5073 16.7836 12.5073 16.5892V15.5785C12.5073 15.397 12.6498 15.2415 12.8442 15.2415C13.0256 15.2415 13.1811 15.3841 13.1811 15.5785V16.6022C13.1811 17.1465 12.7405 17.6 12.1833 17.6H1.99781C1.45355 17.6 1 17.1594 1 16.6022V1.99781C1 1.45355 1.44059 1 1.99781 1H9.22873C9.31944 1 9.39719 1.03888 9.46198 1.10367L13.0645 4.70617C13.1293 4.77096 13.1682 4.84871 13.1682 4.93942Z",
      fill: "#1B1B21",
      stroke: "#1B1B21",
      strokeWidth: "0.518345",
      strokeMiterlimit: "10"
    })
  }));
};
var MP4Icon = function MP4Icon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    width: "14",
    height: "18",
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M13.1682 4.93942V16.2523L12.5073 16.2134V5.08197L9.08618 1.66089H1.99781C1.81639 1.66089 1.67385 1.81639 1.67385 1.99781V16.5892C1.67385 16.7707 1.81639 16.9262 1.99781 16.9262H12.1703C12.3518 16.9262 12.5073 16.7836 12.5073 16.5892V15.5785C12.5073 15.397 12.6498 15.2415 12.8442 15.2415C13.0256 15.2415 13.1811 15.3841 13.1811 15.5785V16.6022C13.1811 17.1465 12.7405 17.6 12.1833 17.6H1.99781C1.45355 17.6 1 17.1594 1 16.6022V1.99781C1 1.45355 1.44059 1 1.99781 1H9.22873C9.31944 1 9.39719 1.03888 9.46198 1.10367L13.0645 4.70617C13.1293 4.77096 13.1682 4.84871 13.1682 4.93942Z",
      fill: "#1B1B21",
      stroke: "#1B1B21",
      strokeWidth: "0.518345",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.831 5.27635H9.88942C9.34515 5.27635 8.8916 4.83575 8.8916 4.27853V1.33692C8.8916 1.20734 8.96935 1.07775 9.09894 1.02592C9.22853 0.974083 9.37107 1 9.46178 1.10367L13.0643 4.70617C13.155 4.79688 13.1939 4.93942 13.142 5.06901C13.0902 5.1986 12.9736 5.27635 12.831 5.27635ZM9.55249 2.14036V4.27853C9.55249 4.45995 9.69504 4.61546 9.88942 4.61546H12.0276L9.55249 2.14036Z",
      fill: "#1B1B21",
      stroke: "#1B1B21",
      strokeWidth: "0.518345",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.36685 12.1444C5.13359 12.1444 4.9133 12.0797 4.70596 11.9501C4.33016 11.7168 4.10986 11.3151 4.10986 10.8745V7.7126C4.10986 7.272 4.33016 6.87029 4.70596 6.63703C5.08176 6.40378 5.53531 6.39082 5.92407 6.5852L9.48769 8.36053C9.83758 8.54195 10.0579 8.89183 10.0579 9.29355C10.0579 9.69527 9.83758 10.0452 9.48769 10.2266L5.92407 12.0149C5.74265 12.1056 5.54827 12.1444 5.36685 12.1444ZM5.36685 7.1165C5.26318 7.1165 5.14655 7.14242 5.05584 7.20721C4.87442 7.32384 4.77075 7.50526 4.77075 7.7126V10.8875C4.77075 11.0948 4.87442 11.2762 5.05584 11.3928C5.23726 11.5095 5.4446 11.5095 5.63898 11.4188L9.2026 9.64343C9.33219 9.57864 9.40994 9.44905 9.40994 9.30651C9.40994 9.16396 9.33219 9.03438 9.2026 8.96958L5.62602 7.18129C5.54827 7.14242 5.45756 7.1165 5.36685 7.1165Z",
      fill: "#1B1B21",
      stroke: "#1B1B21",
      strokeWidth: "0.518345",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.6538 15.2416H5.36671C5.18529 15.2416 5.02979 15.0991 5.02979 14.9047C5.02979 14.7233 5.17233 14.5677 5.36671 14.5677H10.6668C10.8482 14.5677 11.0037 14.7103 11.0037 14.9047C10.9908 15.0991 10.8353 15.2416 10.6538 15.2416Z",
      fill: "#1B1B21",
      stroke: "#1B1B21",
      strokeWidth: "0.518345",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.16138 15.2416H3.66896C3.48753 15.2416 3.33203 15.0991 3.33203 14.9047C3.33203 14.7233 3.47458 14.5677 3.66896 14.5677H4.16138C4.3428 14.5677 4.49831 14.7103 4.49831 14.9047C4.49831 15.0991 4.3428 15.2416 4.16138 15.2416Z",
      fill: "#1B1B21",
      stroke: "#1B1B21",
      strokeWidth: "0.518345",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.77042 15.8377C4.25208 15.8377 3.8374 15.423 3.8374 14.9046C3.8374 14.3863 4.25208 13.9716 4.77042 13.9716C5.28877 13.9716 5.70345 14.3863 5.70345 14.9046C5.69049 15.423 5.27581 15.8377 4.77042 15.8377ZM4.77042 14.6455C4.62788 14.6455 4.49829 14.7621 4.49829 14.9176C4.49829 15.0731 4.61492 15.1897 4.77042 15.1897C4.92593 15.1897 5.04255 15.0731 5.04255 14.9176C5.04255 14.7621 4.91297 14.6455 4.77042 14.6455Z",
      fill: "#1B1B21",
      stroke: "#1B1B21",
      strokeWidth: "0.518345",
      strokeMiterlimit: "10"
    })]
  }));
};
var PdfIcon = function PdfIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: "17",
    height: "18",
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M15.8068 9.83539H12.4298V1.26302C12.4298 1.12014 12.3129 1.00325 12.1701 1.00325H4.94849H4.92251C4.84458 0.990259 4.76665 1.01624 4.7147 1.08118L1.07793 4.71794C1.06494 4.73093 1.05195 4.75691 1.03897 4.7699L1.02598 4.78289C1.01299 4.80886 1.01299 4.82185 1 4.84783C1 4.86082 1 4.88679 1 4.89978V17.3687C1 17.5116 1.1169 17.6285 1.25977 17.6285H12.1701C12.3129 17.6285 12.4298 17.5116 12.4298 17.3687V15.5503H15.8068C15.9497 15.5503 16.0666 15.4334 16.0666 15.2905V10.0952C16.0666 9.95229 15.9497 9.83539 15.8068 9.83539ZM4.63677 1.88646V4.64001H1.88321L4.63677 1.88646ZM11.9103 17.1089H1.51954V5.15955H4.89653C5.03941 5.15955 5.1563 5.04265 5.1563 4.89978V1.52279H11.9103V9.83539H5.80573C5.66285 9.83539 5.54596 9.95229 5.54596 10.0952V15.2905C5.54596 15.4334 5.66285 15.5503 5.80573 15.5503H11.9103V17.1089ZM15.5471 15.0308H6.06549V10.3549H15.5471V15.0308Z",
      fill: "#1B1B21",
      stroke: "#1B1B21",
      strokeWidth: "0.519538",
      strokeMiterlimit: "10"
    })
  }));
};
var MailIcon = function MailIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.4138 1.82143H13.4828V0.607143C13.4828 0.273214 13.219 0 12.8966 0H10.8448C10.5224 0 10.2586 0.273214 10.2586 0.607143V1.82143H6.74138V0.607143C6.74138 0.273214 6.47759 0 6.15517 0H4.10345C3.78103 0 3.51724 0.273214 3.51724 0.607143V1.82143H0.586207C0.263793 1.82143 0 2.09464 0 2.42857V16.3929C0 16.7268 0.263793 17 0.586207 17H16.4138C16.7362 17 17 16.7268 17 16.3929V2.42857C17 2.09464 16.7362 1.82143 16.4138 1.82143ZM11.431 1.21429H12.3103V3.64286H11.431V1.21429ZM4.68966 1.21429H5.56897V3.64286H4.68966V1.21429ZM3.51724 3.03571V4.25C3.51724 4.58393 3.78103 4.85714 4.10345 4.85714H6.15517C6.47759 4.85714 6.74138 4.58393 6.74138 4.25V3.03571H10.2586V4.25C10.2586 4.58393 10.5224 4.85714 10.8448 4.85714H12.8966C13.219 4.85714 13.4828 4.58393 13.4828 4.25V3.03571H15.8276V6.07143H1.17241V3.03571H3.51724ZM1.17241 15.7857V7.28571H15.8276V15.7857H1.17241ZM9.08621 10.9286H11.1379V12.1429H9.08621V14.2679H7.91379V12.1429H5.86207V10.9286H7.91379V8.80357H9.08621V10.9286Z",
      fill: "black"
    })
  }));
};
var ArrowRightIcon = function ArrowRightIcon(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 12",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M1 1l5 5-5 5",
      strokeWidth: "2"
    })
  }));
};
var PlayIcon = function PlayIcon(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M15 8.5L0 17V0L15 8.5Z"
    })
  }));
};
var StopwatchIcon = function StopwatchIcon(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.82 23.64C18.7957 23.64 23.64 18.7957 23.64 12.82C23.64 6.84428 18.7957 2 12.82 2C6.84428 2 2 6.84428 2 12.82C2 18.7957 6.84428 23.64 12.82 23.64ZM12.82 25.64C19.9003 25.64 25.64 19.9003 25.64 12.82C25.64 5.73971 19.9003 0 12.82 0C5.73971 0 0 5.73971 0 12.82C0 19.9003 5.73971 25.64 12.82 25.64Z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.3779 6.18896H13.3779V13.1462H19.451V15.1462H11.3779V6.18896Z"
    })]
  }));
};
var SearchIcon = function SearchIcon(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 19 20",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M12.572 13.106l-.016.016-.016.016a6 6 0 11.032-.032zm2.062.68A8.002 8.002 0 002.657 3.221 8 8 0 0013.22 15.2l4.286 4.286 1.414-1.414-4.286-4.286z"
    })
  }));
};
var CloseFormIcon = function CloseFormIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("rect", {
      width: "1.41421",
      height: "24.0416",
      transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 18.728 0.999969)",
      fill: "#000032"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0.728027",
      y: "0.999969",
      width: "1.41421",
      height: "24.0416",
      transform: "rotate(-45 0.728027 0.999969)",
      fill: "#000032"
    })]
  }));
};
var PlusIcon = function PlusIcon(_ref7) {
  var _ref7$height = _ref7.height,
      height = _ref7$height === void 0 ? 37 : _ref7$height,
      _ref7$width = _ref7.width,
      width = _ref7$width === void 0 ? 37 : _ref7$width;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
    width: width,
    height: height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "0 0 37 37",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
      cx: "18.504",
      cy: "18.705",
      r: "18",
      fill: "#00B67A"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      fill: "#fff",
      d: "M17.503 10.705h2v16h-2z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      fill: "#fff",
      d: "M26.503 17.705v2h-16v-2z"
    })]
  });
};
var TriangleArrow = function TriangleArrow(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", _objectSpread(_objectSpread({
    width: "24",
    height: "20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      d: "M12.866 19.5C12.4811 20.1667 11.5189 20.1667 11.134 19.5L0.741669 1.5C0.35677 0.833332 0.837895 2.92392e-07 1.60769 2.25094e-07L22.3923 -1.59195e-06C23.1621 -1.65925e-06 23.6432 0.833332 23.2583 1.5L12.866 19.5Z",
      fill: "currentColor"
    })
  }));
};

/***/ }),

/***/ 17221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aB": function() { return /* binding */ ArrowedLink; },
  "rU": function() { return /* binding */ Link; },
  "ke": function() { return /* binding */ LinkFromPath; }
});

// UNUSED EXPORTS: StyledLink

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/contexts/index.js + 1 modules
var contexts = __webpack_require__(54447);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(11987);
var native_url_default = /*#__PURE__*/__webpack_require__.n(native_url);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/config.js
var config = __webpack_require__(63852);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/utilities/prop-mappers.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var mapLinkProps = function mapLinkProps(props) {
  var newProps = _objectSpread({}, props);

  if (!newProps.href) {
    return newProps;
  }

  var _url$parse = native_url_default().parse(props.href),
      hostname = _url$parse.hostname;

  if (hostname === null) {
    return newProps;
  }

  switch (true) {
    case /^business\.trustpilot\.com$/.test(hostname):
      break;

    case /^([0-9a-z]+\.)?([0-9a-z]+\.)?trustpilot\.com$/.test(hostname):
      newProps.target = '_blank';
      break;

    case config/* default.specificExternalLinksRegex.test */.Z.specificExternalLinksRegex.test(hostname):
      newProps.target = '_blank';
      newProps.rel = 'noopener sponsored';
      break;

    default:
      newProps.target = '_blank';
      newProps.rel = 'noopener nofollow';
  }

  if (props.target) {
    newProps.target = props.target;
  }

  return newProps;
};
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/components/Links/index.js


var _excluded = ["children", "className", "hrefAs", "onClick"];

function Links_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Links_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Links_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Links_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var StyledLink = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
  displayName: "Links__StyledLink",
  componentId: "sc-nzv42-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme,
      underlined = _ref.underlined;
  return "\n    cursor: pointer;\n    color: ".concat(theme.colors.blueSaturated || 'inherit', ";\n    ").concat(underlined && 'text-decoration: underline', ";\n  ");
});
var LinkFromPath = function LinkFromPath(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      hrefAs = _ref2.hrefAs,
      onClick = _ref2.onClick,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  var enabledTracking = (0,react.useContext)(contexts/* TrackingContext */.Ui);
  var finalOnClick;

  if (enabledTracking.includes('link-clicked')) {
    finalOnClick = function finalOnClick() {
      var _window, _window$analytics;

      (_window = window) === null || _window === void 0 ? void 0 : (_window$analytics = _window.analytics) === null || _window$analytics === void 0 ? void 0 : _window$analytics.track('Link Clicked', {
        location: window.location.pathname,
        url: hrefAs || props.href
      });

      if (typeof onClick === 'function') {
        onClick.apply(void 0, arguments);
      }
    };
  } else {
    finalOnClick = onClick;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, Links_objectSpread(Links_objectSpread({}, mapLinkProps(props)), {}, {
    className: className,
    onClick: finalOnClick,
    href: props.href,
    children: children
  }));
};
var Link = (0,styled_components_browser_esm/* default */.ZP)(LinkFromPath).withConfig({
  displayName: "Links__Link",
  componentId: "sc-nzv42-1"
})(["", " ", " ", " ", ""], index_esm/* color */.$_, index_esm/* space */.Dh, index_esm/* layout */.bK, index_esm/* typography */.cp);
var ArrowedLink = (0,styled_components_browser_esm/* default */.ZP)(Link).withConfig({
  displayName: "Links__ArrowedLink",
  componentId: "sc-nzv42-2"
})(["text-decoration:underline;&::after{content:' \u2192';padding-left:5px;display:inline-block;transition:transform 0.4s ease;}&:hover{&::after{transform:translateX(6px) scaleX(0.9);}}&:active{font-weight:700;}"]);

/***/ }),

/***/ 60348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CY": function() { return /* binding */ DefaultSpacing; },
/* harmony export */   "Ki": function() { return /* binding */ Spacing; }
/* harmony export */ });
/* unused harmony exports spaceRenderers, withSpacing */
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17674);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styling_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39430);
/* harmony import */ var _constants_heights__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89186);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



var _excluded = ["children"],
    _excluded2 = (/* unused pure expression or super */ null && (["spacing"]));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var spaceRenderers = {
  base: function base(_ref, withXPadding) {
    var _ref$top = _ref.top,
        top = _ref$top === void 0 ? null : _ref$top,
        _ref$bottom = _ref.bottom,
        bottom = _ref$bottom === void 0 ? null : _ref$bottom;

    if (top === null && bottom === null && !withXPadding) {
      return '';
    }

    return "\n      padding: ".concat(top || '0', "px ").concat(withXPadding ? '15' : '0', "px ").concat(bottom || '0', "px;\n    ");
  },
  'phone-landscape': function phoneLandscape(_ref2) {
    var _ref2$top = _ref2.top,
        top = _ref2$top === void 0 ? null : _ref2$top,
        _ref2$bottom = _ref2.bottom,
        bottom = _ref2$bottom === void 0 ? null : _ref2$bottom;

    if (top === null && bottom === null) {
      return '';
    }

    return "\n      @media(".concat(_styling_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .phonelandscape */ .l$, ") {\n        ").concat(top !== null ? "padding-top: ".concat(top, "px;") : '', "\n        ").concat(bottom !== null ? "padding-bottom: ".concat(bottom, "px;") : '', "\n      }\n    ");
  },
  tablet: function tablet(_ref3, withXPadding) {
    var _ref3$top = _ref3.top,
        top = _ref3$top === void 0 ? null : _ref3$top,
        _ref3$bottom = _ref3.bottom,
        bottom = _ref3$bottom === void 0 ? null : _ref3$bottom;

    if (top === null && bottom === null && !withXPadding) {
      return '';
    }

    return "\n      @media(".concat(_styling_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .tablets */ .Ye, ") {\n        ").concat(top !== null ? "padding-top: ".concat(top, "px;") : '', "\n        ").concat(bottom !== null ? "padding-bottom: ".concat(bottom, "px;") : '', "\n        ").concat(withXPadding ? "\n          padding-left: 30px;\n          padding-right: 30px;\n        " : '', "\n      }\n    ");
  },
  desktop: function desktop(_ref4) {
    var _ref4$top = _ref4.top,
        top = _ref4$top === void 0 ? null : _ref4$top,
        _ref4$bottom = _ref4.bottom,
        bottom = _ref4$bottom === void 0 ? null : _ref4$bottom;

    if (top === null && bottom === null) {
      return '';
    }

    return "\n      @media(".concat(_styling_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .desktops */ .qf, ") {\n        ").concat(top !== null ? "padding-top: ".concat(top, "px;") : '', "\n        ").concat(bottom !== null ? "padding-bottom: ".concat(bottom, "px;") : '', "\n      }\n    ");
  },
  'desktop-large': function desktopLarge(_ref5) {
    var _ref5$top = _ref5.top,
        top = _ref5$top === void 0 ? null : _ref5$top,
        _ref5$bottom = _ref5.bottom,
        bottom = _ref5$bottom === void 0 ? null : _ref5$bottom;

    if (top === null && bottom === null) {
      return '';
    }

    return "\n      @media(".concat(_styling_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .desktopslarge */ .vo, ") {\n        ").concat(top !== null ? "padding-top: ".concat(top, "px;") : '', "\n        ").concat(bottom !== null ? "padding-bottom: ".concat(bottom, "px;") : '', "\n      }\n    ");
  }
};
var Spacing = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Spacing",
  componentId: "sc-nd6fy-0"
})(["width:100%;", " margin:0 auto;", ""], function (_ref6) {
  var contentWidth = _ref6.contentWidth;
  return contentWidth !== null && typeof contentWidth !== 'undefined' ? "max-width: ".concat(contentWidth, "px;") : '';
}, function (_ref7) {
  var spaces = _ref7.spaces,
      withXPadding = _ref7.withXPadding;
  var arrayedSpaces = Array.isArray(spaces) ? spaces : [spaces || {}];
  var spacingByDevice = arrayedSpaces.reduce(function (acc, _ref8) {
    var device = _ref8.device,
        top = _ref8.top,
        bottom = _ref8.bottom;
    acc[device ? device : 'base'] = {
      top: top,
      bottom: bottom
    };
    return acc;
  }, {});
  return Object.entries(spaceRenderers).reduce(function (acc, _ref9) {
    var _ref10 = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref9, 2),
        deviceName = _ref10[0],
        renderFunction = _ref10[1];

    return "\n      ".concat(acc, "\n\n      ").concat(renderFunction(spacingByDevice[deviceName] || {}, withXPadding), "\n    ");
  }, "");
});
var DefaultSpacing = function DefaultSpacing(_ref11) {
  var children = _ref11.children,
      otherProps = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref11, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Spacing, _objectSpread(_objectSpread({
    spaces: [{
      top: _constants_heights__WEBPACK_IMPORTED_MODULE_7__/* .SPACING_MOBILE */ .KA,
      bottom: _constants_heights__WEBPACK_IMPORTED_MODULE_7__/* .SPACING_MOBILE */ .KA
    }, {
      device: 'tablet',
      top: _constants_heights__WEBPACK_IMPORTED_MODULE_7__/* .SPACING_TABLET */ .vu,
      bottom: _constants_heights__WEBPACK_IMPORTED_MODULE_7__/* .SPACING_TABLET */ .vu
    }, {
      device: 'desktop',
      top: _constants_heights__WEBPACK_IMPORTED_MODULE_7__/* .SPACING_DESKTOP */ .rI,
      bottom: _constants_heights__WEBPACK_IMPORTED_MODULE_7__/* .SPACING_DESKTOP */ .rI
    }]
  }, otherProps), {}, {
    children: children
  }));
};
var withSpacing = function withSpacing() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      contentWidth = _ref12.contentWidth,
      withXPadding = _ref12.withXPadding;

  return function (WrappedComponent) {
    var WithSpacing = function WithSpacing(_ref13) {
      var spacing = _ref13.spacing,
          otherProps = _objectWithoutProperties(_ref13, _excluded2);

      return spacing || contentWidth ? /*#__PURE__*/_jsx(Spacing, {
        spaces: spacing,
        withXPadding: withXPadding !== undefined ? withXPadding : true,
        contentWidth: contentWidth,
        children: /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({}, otherProps))
      }) : /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({}, otherProps));
    };

    return hoistStatics(WithSpacing, WrappedComponent);
  };
};

/***/ }),

/***/ 63852:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
  port: 3000,
  defaultLocaleCode: 'en-US',
  businessBaseUrl: 'business.trustpilot.com',
  legalBaseUrl: 'legal.trustpilot.com',
  consumerBaseUrl: 'trustpilot.com',
  trustpilotLogoURL: 'https://cdn.trustpilot.net/brand-assets/4.1.0/logo-white.svg',
  specificExternalLinksRegex: /^(www\.)?(lagunapearl\.com|payability\.com|planetofthevapes\.com|thepearlsource\.com|docpeter\.it|spediscimi\.li|bssweb\.it)$/
});

/***/ }),

/***/ 83541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UI": function() { return /* binding */ ColorProvider; },
/* harmony export */   "dx": function() { return /* binding */ ColorContext; }
/* harmony export */ });
/* unused harmony export ColorConsumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ColorContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();
var ColorProvider = ColorContext.Provider,
    ColorConsumer = ColorContext.Consumer;


/***/ }),

/***/ 61246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L8": function() { return /* binding */ TrackingProvider; },
/* harmony export */   "Ui": function() { return /* binding */ TrackingContext; }
/* harmony export */ });
/* unused harmony export TrackingConsumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var TrackingContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)([]);
var TrackingProvider = TrackingContext.Provider,
    TrackingConsumer = TrackingContext.Consumer;


/***/ }),

/***/ 54447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dx": function() { return /* reexport */ ColorContext/* ColorContext */.dx; },
  "UI": function() { return /* reexport */ ColorContext/* ColorProvider */.UI; },
  "Ui": function() { return /* reexport */ TrackingContext/* TrackingContext */.Ui; },
  "L8": function() { return /* reexport */ TrackingContext/* TrackingProvider */.L8; }
});

// UNUSED EXPORTS: ColorConsumer, LocaleCodeConsumer, LocaleCodeProvider, LocaleContext, TrackingConsumer

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/contexts/LocaleContext.js

/***
 * DEPRECATED - use the Ilenia Localization provider instead.
 * Check Navigation stories for example of usage.
 */

var LocaleContext = /*#__PURE__*/(0,react.createContext)();
var LocaleCodeProvider = LocaleContext.Provider,
    LocaleCodeConsumer = LocaleContext.Consumer;

// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/contexts/TrackingContext.js
var TrackingContext = __webpack_require__(61246);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/contexts/ColorContext.js
var ColorContext = __webpack_require__(83541);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/contexts/index.js




/***/ }),

/***/ 39430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ye": function() { return /* binding */ tablets; },
/* harmony export */   "gf": function() { return /* binding */ phones; },
/* harmony export */   "l$": function() { return /* binding */ phonelandscape; },
/* harmony export */   "qf": function() { return /* binding */ desktops; },
/* harmony export */   "vo": function() { return /* binding */ desktopslarge; }
/* harmony export */ });
/* harmony import */ var _constants_widths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78033);

var phones = "max-width: ".concat(_constants_widths__WEBPACK_IMPORTED_MODULE_0__/* .TABLET_WIDTH */ .uU - 1, "px");
var phonelandscape = "min-width: ".concat(_constants_widths__WEBPACK_IMPORTED_MODULE_0__/* .PHONE_WIDTH */ .sT, "px");
var tablets = "min-width: ".concat(_constants_widths__WEBPACK_IMPORTED_MODULE_0__/* .TABLET_WIDTH */ .uU, "px");
var desktops = "min-width: ".concat(_constants_widths__WEBPACK_IMPORTED_MODULE_0__/* .DESKTOP_WIDTH */ .JH, "px");
var desktopslarge = "min-width: ".concat(_constants_widths__WEBPACK_IMPORTED_MODULE_0__/* .DESKTOP_LARGE_WIDTH */ .NZ, "px");

/***/ }),

/***/ 55412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ contrastingTextColor; },
/* harmony export */   "d": function() { return /* binding */ getBackgroundColor; }
/* harmony export */ });
/* harmony import */ var _constants_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85279);

var kebabCaseColors = Object.keys(_constants_colors__WEBPACK_IMPORTED_MODULE_0__/* .colorMap */ .Uh).reduce(function (acc, val) {
  var colorName = val.toLowerCase().replace(/_/g, '-');
  acc[colorName] = _constants_colors__WEBPACK_IMPORTED_MODULE_0__/* .colorMap */ .Uh[val];
  return acc;
}, {});
var getBackgroundColor = function getBackgroundColor(colorName) {
  var fallbackToTransparent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return kebabCaseColors[colorName] || (fallbackToTransparent ? 'transparent' : fallbackToTransparent);
};
var contrastingTextColor = function contrastingTextColor(colorName) {
  var colorOptions = {
    'blue-primary': _constants_colors__WEBPACK_IMPORTED_MODULE_0__/* .WHITE */ .Cj,
    'blue-dark': _constants_colors__WEBPACK_IMPORTED_MODULE_0__/* .WHITE */ .Cj,
    'blue-light': _constants_colors__WEBPACK_IMPORTED_MODULE_0__/* .WHITE */ .Cj,
    salmon: _constants_colors__WEBPACK_IMPORTED_MODULE_0__/* .BLUE_PRIMARY */ .jc,
    green: _constants_colors__WEBPACK_IMPORTED_MODULE_0__/* .WHITE */ .Cj,
    gray: _constants_colors__WEBPACK_IMPORTED_MODULE_0__/* .BLUE_PRIMARY */ .jc,
    pink: _constants_colors__WEBPACK_IMPORTED_MODULE_0__/* .BLUE_PRIMARY */ .jc,
    white: _constants_colors__WEBPACK_IMPORTED_MODULE_0__/* .BLUE_PRIMARY */ .jc
  };
  return colorOptions[colorName] || 'inherit';
};

/***/ }),

/***/ 14364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hy": function() { return /* binding */ trackVideoPlayed; },
/* harmony export */   "L7": function() { return /* binding */ trackFormFieldFocus; },
/* harmony export */   "Ng": function() { return /* binding */ trackLinkClick; },
/* harmony export */   "kO": function() { return /* binding */ trackButtonClick; },
/* harmony export */   "rV": function() { return /* binding */ trackFormSubmitted; },
/* harmony export */   "u9": function() { return /* binding */ getUTMCookies; },
/* harmony export */   "zu": function() { return /* binding */ trackDataActionClick; }
/* harmony export */ });
/* unused harmony exports getRouterQueries, getTrackingParameters, trackListFiltered */
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31955);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var UTMWhitelist = ['utm_term', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
var paramWhitelist = [].concat(UTMWhitelist, ['path', 'label', 'form', 'demo', 'context', 'url', 'search', 'name', 'cta', 'channel', 'referrer', 'country', 'email', 'testUser', 'category', 'lastName', 'target']);
var getRouterQueries = function getRouterQueries() {
  var _Router$router;

  return ((next_router__WEBPACK_IMPORTED_MODULE_2___default()) === null || (next_router__WEBPACK_IMPORTED_MODULE_2___default()) === void 0 ? void 0 : (_Router$router = (next_router__WEBPACK_IMPORTED_MODULE_2___default().router)) === null || _Router$router === void 0 ? void 0 : _Router$router.query) || {};
};
var getTrackingParameters = function getTrackingParameters() {
  var queryStringObj = getRouterQueries();
  var queryParams = paramWhitelist.reduce(function (acc, curr) {
    acc[curr] = queryStringObj[curr];
    return acc;
  }, {});
  return _objectSpread(_objectSpread({}, queryParams), {}, {
    context: 'businesssite'
  });
};
var getUTMCookies = function getUTMCookies() {
  return UTMWhitelist.reduce(function (acc, current) {
    acc["".concat(current, "_origin")] = js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("".concat(current, "_origin"));
    acc[current] = js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("".concat(current, "_recent"));
    return acc;
  }, {});
};
var trackDataActionClick = function trackDataActionClick(event) {
  if (event.currentTarget.dataset.action) {
    var _window, _window$analytics;

    (_window = window) === null || _window === void 0 ? void 0 : (_window$analytics = _window.analytics) === null || _window$analytics === void 0 ? void 0 : _window$analytics.track('NavigationClicked', _objectSpread(_objectSpread({}, getTrackingParameters()), {}, {
      action: 'NavigationClicked',
      label: event.currentTarget.dataset.action,
      category: event.currentTarget.dataset.category
    }));
    trackLinkClick({
      label: event.currentTarget.dataset.action,
      href: event.currentTarget.href
    });
  }
};
/**
 * Event values are: form, action, label, value, category, placement, country
 */

var trackFormSubmitted = function trackFormSubmitted(eventValues) {
  var _window2, _window2$analytics;

  var url = window.location.toString();
  var urlObj = new URL(url);
  return (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$analytics = _window2.analytics) === null || _window2$analytics === void 0 ? void 0 : _window2$analytics.track('Form Submitted', _objectSpread(_objectSpread(_objectSpread({}, getTrackingParameters()), eventValues), {}, {
    source: "".concat(urlObj.protocol, "//").concat(urlObj.host).concat(urlObj.pathname),
    cta: urlObj.searchParams.get('cta'),
    category: 'businesssite'
  }, getUTMCookies()));
};
var trackLinkClick = function trackLinkClick(_ref) {
  var _window3, _window3$analytics;

  var label = _ref.label,
      href = _ref.href;
  var url = window.location.toString();
  var urlObj = new URL(url);
  var cleanedHref = href.indexOf('?') > -1 ? href.split('?')[0] : href;
  (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$analytics = _window3.analytics) === null || _window3$analytics === void 0 ? void 0 : _window3$analytics.track('Link Clicked', _objectSpread(_objectSpread({}, getTrackingParameters()), {}, {
    target: cleanedHref,
    name: label,
    location: urlObj.pathname,
    page: document.title
  }));
};
var trackFormFieldFocus = function trackFormFieldFocus(e, formEventName) {
  var _window4, _window4$analytics;

  (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$analytics = _window4.analytics) === null || _window4$analytics === void 0 ? void 0 : _window4$analytics.track('FormFieldFocused', _objectSpread(_objectSpread({}, getTrackingParameters()), {}, {
    target: e.target.name,
    form: formEventName
  }));
};
var trackButtonClick = function trackButtonClick(_ref2) {
  var _window5, _window5$analytics;

  var label = _ref2.label,
      location = _ref2.location,
      _ref2$placement = _ref2.placement,
      placement = _ref2$placement === void 0 ? 'page body' : _ref2$placement;
  var cleanedLocation = location.indexOf('?') > -1 ? location.split('?')[0] : location;
  (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$analytics = _window5.analytics) === null || _window5$analytics === void 0 ? void 0 : _window5$analytics.track('Button Clicked', _objectSpread(_objectSpread({}, getTrackingParameters()), {}, {
    label: label,
    name: label,
    placement: placement,
    location: cleanedLocation
  }));
};
var trackListFiltered = function trackListFiltered(_ref3) {
  var _window6, _window6$analytics;

  var label = _ref3.label,
      location = _ref3.location,
      selection = _ref3.selection;
  return (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$analytics = _window6.analytics) === null || _window6$analytics === void 0 ? void 0 : _window6$analytics.track('List Filtered', {
    label: label,
    location: location,
    selection: selection
  });
};
var trackVideoPlayed = function trackVideoPlayed(url) {
  var _window$analytics2;

  return (_window$analytics2 = window.analytics) === null || _window$analytics2 === void 0 ? void 0 : _window$analytics2.track('Video Played', _objectSpread(_objectSpread({}, getTrackingParameters()), {}, {
    location: window.location.href,
    videoUrl: url
  }));
};

/***/ }),

/***/ 53333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useTranslations; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89184);


function useTranslations() {
  var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .LocalizationContext */ .d);
  return [context.translations, context.locale];
}

/***/ }),

/***/ 96086:
/***/ (function(module) {

"use strict";

var assign = Object.assign.bind(Object);
module.exports = assign;
module.exports["default"] = module.exports;

//# sourceMappingURL=object-assign.js.map

/***/ }),

/***/ 11987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var e={477:function(e){"use strict";e.exports=__webpack_require__(97334)}};var t={};function __nccwpck_require__(o){var a=t[o];if(a!==undefined){return a.exports}var s=t[o]={exports:{}};var n=true;try{e[o](s,s.exports,__nccwpck_require__);n=false}finally{if(n)delete t[o]}return s.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var o={};!function(){var e=o;var t,a=(t=__nccwpck_require__(477))&&"object"==typeof t&&"default"in t?t.default:t,s=/https?|ftp|gopher|file/;function r(e){"string"==typeof e&&(e=d(e));var t=function(e,t,o){var a=e.auth,s=e.hostname,n=e.protocol||"",p=e.pathname||"",c=e.hash||"",i=e.query||"",u=!1;a=a?encodeURIComponent(a).replace(/%3A/i,":")+"@":"",e.host?u=a+e.host:s&&(u=a+(~s.indexOf(":")?"["+s+"]":s),e.port&&(u+=":"+e.port)),i&&"object"==typeof i&&(i=t.encode(i));var f=e.search||i&&"?"+i||"";return n&&":"!==n.substr(-1)&&(n+=":"),e.slashes||(!n||o.test(n))&&!1!==u?(u="//"+(u||""),p&&"/"!==p[0]&&(p="/"+p)):u||(u=""),c&&"#"!==c[0]&&(c="#"+c),f&&"?"!==f[0]&&(f="?"+f),{protocol:n,host:u,pathname:p=p.replace(/[?#]/g,encodeURIComponent),search:f=f.replace("#","%23"),hash:c}}(e,a,s);return""+t.protocol+t.host+t.pathname+t.search+t.hash}var n="http://",p="w.w",c=n+p,i=/^([a-z0-9.+-]*:\/\/\/)([a-z0-9.+-]:\/*)?/i,u=/https?|ftp|gopher|file/;function h(e,t){var o="string"==typeof e?d(e):e;e="object"==typeof e?r(e):e;var a=d(t),s="";o.protocol&&!o.slashes&&(s=o.protocol,e=e.replace(o.protocol,""),s+="/"===t[0]||"/"===e[0]?"/":""),s&&a.protocol&&(s="",a.slashes||(s=a.protocol,t=t.replace(a.protocol,"")));var p=e.match(i);p&&!a.protocol&&(e=e.substr((s=p[1]+(p[2]||"")).length),/^\/\/[^/]/.test(t)&&(s=s.slice(0,-1)));var f=new URL(e,c+"/"),m=new URL(t,f).toString().replace(c,""),v=a.protocol||o.protocol;return v+=o.slashes||a.slashes?"//":"",!s&&v?m=m.replace(n,v):s&&(m=m.replace(n,"")),u.test(m)||~t.indexOf(".")||"/"===e.slice(-1)||"/"===t.slice(-1)||"/"!==m.slice(-1)||(m=m.slice(0,-1)),s&&(m=s+("/"===m[0]?m.substr(1):m)),m}function l(){}l.prototype.parse=d,l.prototype.format=r,l.prototype.resolve=h,l.prototype.resolveObject=h;var f=/^https?|ftp|gopher|file/,m=/^(.*?)([#?].*)/,v=/^([a-z0-9.+-]*:)(\/{0,3})(.*)/i,_=/^([a-z0-9.+-]*:)?\/\/\/*/i,b=/^([a-z0-9.+-]*:)(\/{0,2})\[(.*)\]$/i;function d(e,t,o){if(void 0===t&&(t=!1),void 0===o&&(o=!1),e&&"object"==typeof e&&e instanceof l)return e;var s=(e=e.trim()).match(m);e=s?s[1].replace(/\\/g,"/")+s[2]:e.replace(/\\/g,"/"),b.test(e)&&"/"!==e.slice(-1)&&(e+="/");var n=!/(^javascript)/.test(e)&&e.match(v),i=_.test(e),u="";n&&(f.test(n[1])||(u=n[1].toLowerCase(),e=""+n[2]+n[3]),n[2]||(i=!1,f.test(n[1])?(u=n[1],e=""+n[3]):e="//"+n[3]),3!==n[2].length&&1!==n[2].length||(u=n[1],e="/"+n[3]));var g,y=(s?s[1]:e).match(/^https?:\/\/[^/]+(:[0-9]+)(?=\/|$)/),w=y&&y[1],C=new l,U="",j="";try{g=new URL(e)}catch(t){U=t,u||o||!/^\/\//.test(e)||/^\/\/.+[@.]/.test(e)||(j="/",e=e.substr(1));try{g=new URL(e,c)}catch(e){return C.protocol=u,C.href=u,C}}C.slashes=i&&!j,C.host=g.host===p?"":g.host,C.hostname=g.hostname===p?"":g.hostname.replace(/(\[|\])/g,""),C.protocol=U?u||null:g.protocol,C.search=g.search.replace(/\\/g,"%5C"),C.hash=g.hash.replace(/\\/g,"%5C");var x=e.split("#");!C.search&&~x[0].indexOf("?")&&(C.search="?"),C.hash||""!==x[1]||(C.hash="#"),C.query=t?a.decode(g.search.substr(1)):C.search.substr(1),C.pathname=j+(n?function(e){return e.replace(/['^|`]/g,(function(e){return"%"+e.charCodeAt().toString(16).toUpperCase()})).replace(/((?:%[0-9A-F]{2})+)/g,(function(e,t){try{return decodeURIComponent(t).split("").map((function(e){var t=e.charCodeAt();return t>256||/^[a-z0-9]$/i.test(e)?e:"%"+t.toString(16).toUpperCase()})).join("")}catch(e){return t}}))}(g.pathname):g.pathname),"about:"===C.protocol&&"blank"===C.pathname&&(C.protocol="",C.pathname=""),U&&"/"!==e[0]&&(C.pathname=C.pathname.substr(1)),u&&!f.test(u)&&"/"!==e.slice(-1)&&"/"===C.pathname&&(C.pathname=""),C.path=C.pathname+C.search,C.auth=[g.username,g.password].map(decodeURIComponent).filter(Boolean).join(":"),C.port=g.port,w&&!C.host.endsWith(w)&&(C.host+=w,C.port=w.slice(1)),C.href=j?""+C.pathname+C.search+C.hash:r(C);var q=/^(file)/.test(C.href)?["host","hostname"]:[];return Object.keys(C).forEach((function(e){~q.indexOf(e)||(C[e]=C[e]||null)})),C}e.parse=d,e.format=r,e.resolve=h,e.resolveObject=function(e,t){return d(h(e,t))},e.Url=l}();module.exports=o})();

/***/ }),

/***/ 97334:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={815:function(e){function hasOwnProperty(e,r){return Object.prototype.hasOwnProperty.call(e,r)}e.exports=function(e,n,t,o){n=n||"&";t=t||"=";var a={};if(typeof e!=="string"||e.length===0){return a}var i=/\+/g;e=e.split(n);var u=1e3;if(o&&typeof o.maxKeys==="number"){u=o.maxKeys}var c=e.length;if(u>0&&c>u){c=u}for(var p=0;p<c;++p){var f=e[p].replace(i,"%20"),s=f.indexOf(t),_,l,y,d;if(s>=0){_=f.substr(0,s);l=f.substr(s+1)}else{_=f;l=""}y=decodeURIComponent(_);d=decodeURIComponent(l);if(!hasOwnProperty(a,y)){a[y]=d}else if(r(a[y])){a[y].push(d)}else{a[y]=[a[y],d]}}return a};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"}},577:function(e){var stringifyPrimitive=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,o,a){t=t||"&";o=o||"=";if(e===null){e=undefined}if(typeof e==="object"){return map(n(e),(function(n){var a=encodeURIComponent(stringifyPrimitive(n))+o;if(r(e[n])){return map(e[n],(function(e){return a+encodeURIComponent(stringifyPrimitive(e))})).join(t)}else{return a+encodeURIComponent(stringifyPrimitive(e[n]))}})).join(t)}if(!a)return"";return encodeURIComponent(stringifyPrimitive(a))+o+encodeURIComponent(stringifyPrimitive(e))};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"};function map(e,r){if(e.map)return e.map(r);var n=[];for(var t=0;t<e.length;t++){n.push(r(e[t],t))}return n}var n=Object.keys||function(e){var r=[];for(var n in e){if(Object.prototype.hasOwnProperty.call(e,n))r.push(n)}return r}}};var r={};function __nccwpck_require__(n){var t=r[n];if(t!==undefined){return t.exports}var o=r[n]={exports:{}};var a=true;try{e[n](o,o.exports,__nccwpck_require__);a=false}finally{if(a)delete r[n]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.decode=e.parse=__nccwpck_require__(815);e.encode=e.stringify=__nccwpck_require__(577)}();module.exports=n})();

/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(77913)


/***/ }),

/***/ 57247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cg": function() { return /* reexport */ border; },
  "$_": function() { return /* reexport */ color; },
  "GQ": function() { return /* reexport */ flexbox; },
  "eC": function() { return /* reexport */ grid; },
  "bK": function() { return /* reexport */ layout; },
  "FK": function() { return /* reexport */ position; },
  "Dh": function() { return /* reexport */ space; },
  "cp": function() { return /* reexport */ typography; },
  "bU": function() { return /* reexport */ variant; }
});

// UNUSED EXPORTS: alignContent, alignItems, alignSelf, background, backgroundImage, backgroundPosition, backgroundRepeat, backgroundSize, borderBottom, borderColor, borderLeft, borderRadius, borderRight, borderStyle, borderTop, borderWidth, borders, bottom, boxShadow, buttonStyle, colorStyle, compose, createParser, createStyleFunction, display, flex, flexBasis, flexDirection, flexGrow, flexShrink, flexWrap, fontFamily, fontSize, fontStyle, fontWeight, get, gridArea, gridAutoColumns, gridAutoFlow, gridAutoRows, gridColumn, gridColumnGap, gridGap, gridRow, gridRowGap, gridTemplateAreas, gridTemplateColumns, gridTemplateRows, height, justifyContent, justifyItems, justifySelf, left, letterSpacing, lineHeight, margin, maxHeight, maxWidth, minHeight, minWidth, opacity, order, overflow, overflowX, overflowY, padding, right, shadow, size, style, system, textAlign, textShadow, textStyle, top, verticalAlign, width, zIndex

// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/object-assign.js
var object_assign = __webpack_require__(96086);
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);
;// CONCATENATED MODULE: ./node_modules/@styled-system/core/dist/index.esm.js

var merge = function merge(a, b) {
  var result = object_assign_default()({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    object_assign_default()(result, (_assign = {}, _assign[key] = object_assign_default()(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue = function getValue(n, scale) {
  return get(scale, n, n);
};

var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var index_esm_createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      object_assign_default()(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      object_assign_default()(styles, style);
    } else {
      var _assign2;

      object_assign_default()(styles, (_assign2 = {}, _assign2[media] = object_assign_default()({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      object_assign_default()(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      object_assign_default()(styles, (_assign3 = {}, _assign3[media] = object_assign_default()({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var index_esm_createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = index_esm_createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = index_esm_createStyleFunction(conf);
  });
  var parser = index_esm_createParser(config);
  return parser;
};
var compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    object_assign_default()(config, parser.config);
  });
  var parser = index_esm_createParser(config);
  return parser;
};

;// CONCATENATED MODULE: ./node_modules/@styled-system/layout/dist/index.esm.js


var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth = function getWidth(n, scale) {
  return get(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + '%');
};

var config = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config);
/* harmony default export */ var index_esm = (layout);

;// CONCATENATED MODULE: ./node_modules/@styled-system/color/dist/index.esm.js

var index_esm_config = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
index_esm_config.bg = index_esm_config.backgroundColor;
var color = system(index_esm_config);
/* harmony default export */ var dist_index_esm = (color);

;// CONCATENATED MODULE: ./node_modules/@styled-system/typography/dist/index.esm.js

var index_esm_defaults = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var dist_index_esm_config = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: index_esm_defaults.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography = system(dist_index_esm_config);
/* harmony default export */ var typography_dist_index_esm = (typography);

;// CONCATENATED MODULE: ./node_modules/@styled-system/flexbox/dist/index.esm.js

var flexbox_dist_index_esm_config = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(flexbox_dist_index_esm_config);
/* harmony default export */ var flexbox_dist_index_esm = (flexbox);

;// CONCATENATED MODULE: ./node_modules/@styled-system/grid/dist/index.esm.js

var dist_index_esm_defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var grid_dist_index_esm_config = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: dist_index_esm_defaults.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: dist_index_esm_defaults.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: dist_index_esm_defaults.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system(grid_dist_index_esm_config);
/* harmony default export */ var grid_dist_index_esm = (grid);

;// CONCATENATED MODULE: ./node_modules/@styled-system/border/dist/index.esm.js

var border_dist_index_esm_config = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  }
};
border_dist_index_esm_config.borderTopWidth = {
  property: 'borderTopWidth',
  scale: 'borderWidths'
};
border_dist_index_esm_config.borderTopColor = {
  property: 'borderTopColor',
  scale: 'colors'
};
border_dist_index_esm_config.borderTopStyle = {
  property: 'borderTopStyle',
  scale: 'borderStyles'
};
border_dist_index_esm_config.borderTopLeftRadius = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
};
border_dist_index_esm_config.borderTopRightRadius = {
  property: 'borderTopRightRadius',
  scale: 'radii'
};
border_dist_index_esm_config.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
};
border_dist_index_esm_config.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
};
border_dist_index_esm_config.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
};
border_dist_index_esm_config.borderBottomLeftRadius = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
};
border_dist_index_esm_config.borderBottomRightRadius = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
};
border_dist_index_esm_config.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
};
border_dist_index_esm_config.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
};
border_dist_index_esm_config.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
};
border_dist_index_esm_config.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
};
border_dist_index_esm_config.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
};
border_dist_index_esm_config.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
};
var border = system(border_dist_index_esm_config);
/* harmony default export */ var border_dist_index_esm = (border);

;// CONCATENATED MODULE: ./node_modules/@styled-system/background/dist/index.esm.js

var background_dist_index_esm_config = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
background_dist_index_esm_config.bgImage = background_dist_index_esm_config.backgroundImage;
background_dist_index_esm_config.bgSize = background_dist_index_esm_config.backgroundSize;
background_dist_index_esm_config.bgPosition = background_dist_index_esm_config.backgroundPosition;
background_dist_index_esm_config.bgRepeat = background_dist_index_esm_config.backgroundRepeat;
var background = system(background_dist_index_esm_config);
/* harmony default export */ var background_dist_index_esm = (background);

;// CONCATENATED MODULE: ./node_modules/@styled-system/position/dist/index.esm.js

var position_dist_index_esm_defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var position_dist_index_esm_config = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  }
};
var position = system(position_dist_index_esm_config);
/* harmony default export */ var position_dist_index_esm = (position);

;// CONCATENATED MODULE: ./node_modules/@styled-system/space/dist/index.esm.js

var space_dist_index_esm_defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var index_esm_isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getMargin = function getMargin(n, scale) {
  if (!index_esm_isNumber(n)) {
    return get(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get(scale, absolute, absolute);

  if (!index_esm_isNumber(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
var space = compose(margin, padding);
/* harmony default export */ var space_dist_index_esm = ((/* unused pure expression or super */ null && (space)));

;// CONCATENATED MODULE: ./node_modules/@styled-system/shadow/dist/index.esm.js

var shadow = system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});
/* harmony default export */ var shadow_dist_index_esm = ((/* unused pure expression or super */ null && (shadow)));

;// CONCATENATED MODULE: ./node_modules/@styled-system/css/dist/index.esm.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// based on https://github.com/developit/dlv
var index_esm_get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  outlineColor: 'colors',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return index_esm_get(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = index_esm_get(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = index_esm_get(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};
var css = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends({}, defaultTheme, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(index_esm_get(theme, val))(theme);
        result = _extends({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = index_esm_get(aliases, key, key);
      var scaleName = index_esm_get(scales, prop);
      var scale = index_esm_get(theme, scaleName, index_esm_get(theme, prop, {}));
      var transform = index_esm_get(transforms, prop, index_esm_get);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};
/* harmony default export */ var css_dist_index_esm = (css);

;// CONCATENATED MODULE: ./node_modules/@styled-system/variant/dist/index.esm.js


var variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return css_dist_index_esm(get(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return get(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = index_esm_createParser(config);
  return parser;
};
/* harmony default export */ var variant_dist_index_esm = ((/* unused pure expression or super */ null && (variant)));
var buttonStyle = variant({
  key: 'buttons'
});
var textStyle = variant({
  key: 'textStyles',
  prop: 'textStyle'
});
var colorStyle = variant({
  key: 'colorStyles',
  prop: 'colors'
});

;// CONCATENATED MODULE: ./node_modules/styled-system/dist/index.esm.js
 // v4 api shims






















var width = index_esm.width,
    height = index_esm.height,
    minWidth = index_esm.minWidth,
    minHeight = index_esm.minHeight,
    maxWidth = index_esm.maxWidth,
    maxHeight = index_esm.maxHeight,
    size = index_esm.size,
    verticalAlign = index_esm.verticalAlign,
    display = index_esm.display,
    overflow = index_esm.overflow,
    overflowX = index_esm.overflowX,
    overflowY = index_esm.overflowY;
var opacity = dist_index_esm.opacity;
var fontSize = typography_dist_index_esm.fontSize,
    fontFamily = typography_dist_index_esm.fontFamily,
    fontWeight = typography_dist_index_esm.fontWeight,
    lineHeight = typography_dist_index_esm.lineHeight,
    textAlign = typography_dist_index_esm.textAlign,
    fontStyle = typography_dist_index_esm.fontStyle,
    letterSpacing = typography_dist_index_esm.letterSpacing;
var alignItems = flexbox_dist_index_esm.alignItems,
    alignContent = flexbox_dist_index_esm.alignContent,
    justifyItems = flexbox_dist_index_esm.justifyItems,
    justifyContent = flexbox_dist_index_esm.justifyContent,
    flexWrap = flexbox_dist_index_esm.flexWrap,
    flexDirection = flexbox_dist_index_esm.flexDirection,
    flex = flexbox_dist_index_esm.flex,
    flexGrow = flexbox_dist_index_esm.flexGrow,
    flexShrink = flexbox_dist_index_esm.flexShrink,
    flexBasis = flexbox_dist_index_esm.flexBasis,
    justifySelf = flexbox_dist_index_esm.justifySelf,
    alignSelf = flexbox_dist_index_esm.alignSelf,
    order = flexbox_dist_index_esm.order;
var gridGap = grid_dist_index_esm.gridGap,
    gridColumnGap = grid_dist_index_esm.gridColumnGap,
    gridRowGap = grid_dist_index_esm.gridRowGap,
    gridColumn = grid_dist_index_esm.gridColumn,
    gridRow = grid_dist_index_esm.gridRow,
    gridAutoFlow = grid_dist_index_esm.gridAutoFlow,
    gridAutoColumns = grid_dist_index_esm.gridAutoColumns,
    gridAutoRows = grid_dist_index_esm.gridAutoRows,
    gridTemplateColumns = grid_dist_index_esm.gridTemplateColumns,
    gridTemplateRows = grid_dist_index_esm.gridTemplateRows,
    gridTemplateAreas = grid_dist_index_esm.gridTemplateAreas,
    gridArea = grid_dist_index_esm.gridArea;
var borderWidth = border_dist_index_esm.borderWidth,
    borderStyle = border_dist_index_esm.borderStyle,
    borderColor = border_dist_index_esm.borderColor,
    borderTop = border_dist_index_esm.borderTop,
    borderRight = border_dist_index_esm.borderRight,
    borderBottom = border_dist_index_esm.borderBottom,
    borderLeft = border_dist_index_esm.borderLeft,
    borderRadius = border_dist_index_esm.borderRadius;
var backgroundImage = background_dist_index_esm.backgroundImage,
    backgroundSize = background_dist_index_esm.backgroundSize,
    backgroundPosition = background_dist_index_esm.backgroundPosition,
    backgroundRepeat = background_dist_index_esm.backgroundRepeat;
var zIndex = position_dist_index_esm.zIndex,
    index_esm_top = position_dist_index_esm.top,
    right = position_dist_index_esm.right,
    bottom = position_dist_index_esm.bottom,
    left = position_dist_index_esm.left;

 // v4 style API shim

var style = function style(_ref) {
  var prop = _ref.prop,
      cssProperty = _ref.cssProperty,
      alias = _ref.alias,
      key = _ref.key,
      transformValue = _ref.transformValue,
      scale = _ref.scale,
      properties = _ref.properties;
  var config = {};
  config[prop] = createStyleFunction({
    properties: properties,
    property: cssProperty || prop,
    scale: key,
    defaultScale: scale,
    transform: transformValue
  });
  if (alias) config[alias] = config[prop];
  var parse = createParser(config);
  return parse;
};


/***/ }),

/***/ 31955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ __webpack_exports__["Z"] = (api);


/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 14666:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 14882:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 17674:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(14666);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(14882);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ })

}]);